/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export const LEASE_STATUS_ENDED = 'ended'
export const LEASE_STATUS_NOTICE = 'notice'
export const LEASE_STATUS_ONGOING = 'ongoing'
export const LEASE_STATUS_TO_COME_UP = 'to_come_up'

export const LeaseStatusCodes = [
  LEASE_STATUS_ENDED,
  LEASE_STATUS_NOTICE,
  LEASE_STATUS_ONGOING,
  LEASE_STATUS_TO_COME_UP
]
